import React from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="flex h-screen w-full bg-[#f5f6fa]" data-id="element-119">
      <Sidebar data-id="element-120" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-121">
        <TopBar data-id="element-122" />
        <main className="flex-1 overflow-y-auto p-6 relative" data-id="element-123">{children}</main>
      </div>
    </div>;
};
export default Layout;